/**
 * E-mails and phones (D-238): each of a channel — e-mail, phone, other — and of a kind saying what
 * it is for (work, private, a secretariat, the company's main one). The dictionary
 * `contact_point_kind` says which channels each kind is offered for (`meta.channels`).
 */
export const CHANNELS = ['email', 'phone', 'other']

const BUILT_IN = {
  work: ['phone', 'email'], private: ['phone', 'email'], secretariat: ['phone', 'email'], main: ['phone', 'email'],
  fax: ['phone'], other: ['phone', 'email', 'other'],
}

/** The active kinds a channel offers: [{key, label}]. */
export function kindsFor(meta, channel) {
  const entries = meta.dictionary('contact_point_kind').entries || []
  const list = entries.length
    ? entries.filter((e) => e.is_active !== false).map((e) => ({ key: e.key, label: meta.localized(e.label), channels: e.meta?.channels || BUILT_IN[e.key] || CHANNELS }))
    : Object.entries(BUILT_IN).map(([key, channels]) => ({ key, label: key, channels }))
  return list.filter((k) => k.channels.includes(channel)).map(({ key, label }) => ({ key, label }))
}

/** A channel's main one, else its first. */
export function primaryOf(points, channel) {
  const of = (points || []).filter((p) => p.channel === channel)
  return of.find((p) => p.is_primary) || of[0] || null
}

/**
 * Said beside a number dialled for a company, not a person (D-250): "company number · Company main".
 * Empty for a person's number.
 */
export function companyNumber(person, meta, t) {
  if (person?.entity !== 'account' || !person.phone) return ''
  const kind = person.phone_kind ? meta.dictionaryLabel('contact_point_kind', person.phone_kind) : ''
  return [t('activity.call.companyNumber'), kind].filter(Boolean).join(' · ')
}
